import {
  Card, CardHeader, CardTitle, CardDescription, CardContent
} from '@/components/ui/card'
import { CheckCircle2, XCircle, History } from 'lucide-react'

import { formatTimestamp } from '@helpers/format'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

const Item = ({ label, value }) => (
  <div className='px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
    <dt className='font-medium text-sm'>{label}</dt>
    <dd className='mt-1 leading-6 text-muted-foreground sm:col-span-2 sm:mt-0 text-sm'>{value}</dd>
  </div>
)

const Overview = ({ name, createdAt, verificationStatus, educatorCount }) => (
  <Card className='w-auto my-3'>
    <CardHeader className="pb-3">
      <CardTitle className='text-2xl'>{name}</CardTitle>
      <CardDescription className='mt-1'>Organization details.</CardDescription>
    </CardHeader>

    <CardContent className="pt-0">
      <dl className='divide-y divide-border'>
        <Item
          label='Verification status'
          value={
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Choose>
                    <When condition={verificationStatus === 'VERIFIED'}>
                      <CheckCircle2 className='w-6 h-6' />
                    </When>
                    <When condition={verificationStatus === 'PENDING'}>
                      <History className='w-6 h-6' />
                    </When>
                    <Otherwise>
                      <XCircle className='w-6 h-6' />
                    </Otherwise>
                  </Choose>
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    <Choose>
                      <When condition={verificationStatus === 'VERIFIED'}>Verified</When>
                      <When condition={verificationStatus === 'PENDING'}>Pending</When>
                      <Otherwise>Rejected</Otherwise>
                    </Choose>
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          }
        />
        <Item label='Signed up' value={formatTimestamp(createdAt)} />
        <Item label='Number of educators' value={educatorCount} />
      </dl>
    </CardContent>
  </Card>
)

export default Overview
